let urlHttp = window.location.href
let urlHead = 'https'
if (urlHttp.includes('https')) {
    urlHead = 'https'
}
// export const ApiUrl = 'http://dlgjxyapi.kjcxchina.com';
// export const ApiUrl = 'https://qzgjxyadmin.kjcxchina.com';
//判断客户端
export const IsPC = () => {
    const userAgentInfo = navigator.userAgent;
    const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];

    let flag = true;

    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break
        }
    }

    return flag
};
// 验证手机号
export const IsRegular = (data) => {
    return /^1[3456789]\d{9}$/.test(data)
}
// 验证身份证号
export const VerificationCard = (data) => {
    return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(data)
}
//判断是否为微信浏览器
export const IsWeiXin = () => {
    const ua = navigator.userAgent.toLowerCase();
    const isWeixin = ua.indexOf('micromessenger') != -1;

    if (isWeixin) {
        return true;
    } else {
        return false;
    }
}

//手机号/邮箱脱敏
export const Desensitization = (data) => {
    if (data.includes('@')) {
        let email = data.split('@');
        if (email[0].length > 4) {
            return email[0].substring(0, email[0].length - 3) + '*****' + email[1];
        } else {
            return '*****' + email[1];
        }
    } else {
        return data.slice(0, 3) + "****" + data.slice(data.length - 4);
    }
}

const QuillToolbarOptions = [
    ['bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block', { 'header': 1 }, { 'header': 2 }, { 'list': 'ordered' }, { 'list': 'bullet' }, { 'script': 'sub' }, { 'script': 'super' }, { 'indent': '-1' }, { 'indent': '+1' }, { 'direction': 'rtl' }, { 'size': ['small', false, 'large', 'huge'] }, { 'header': [1, 2, 3, 4, 5, 6, false] }, { 'font': [] }, { 'color': [] }, { 'background': [] }, { 'align': [] }, 'link', 'image', 'video', 'clean'],         // toggled buttons
];

export const QuillEditorOption = {
    placeholder: '请填写内容',
    modules: {
        imageResize: {
            displayStyles: {
                backgroundColor: 'black',
                border: 'none',
                color: 'white'
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar']
        },
        toolbar: {
            container: QuillToolbarOptions,  // 工具栏
        }
    }
}

export const downloadFile = (url, fileName) =>{
    const x = new XMLHttpRequest()
    x.open("GET", url, true)
    x.responseType = 'blob'
    x.onload = function(e) {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.target = '_blank'
        a.download = fileName
        a.click()
        a.remove()
    }
    x.send()
}

export const copyToClipboard = (text) => {
    let tempInput = document.createElement("input");
    document.body.appendChild(tempInput);
    tempInput.value = text;
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
 }